import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "infographics-container" }
const _hoisted_3 = { class: "infographics-header-block text-center" }
const _hoisted_4 = { class: "infographics-logo" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", null, "CONVORALLY", -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "step-tab" }
const _hoisted_8 = { class: "step-content" }
const _hoisted_9 = { class: "box-container scrollable" }
const _hoisted_10 = { class: "invitation-heading" }
const _hoisted_11 = { class: "uppercase-text" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "invitation-desc" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-7" }
const _hoisted_16 = { class: "add-member-desc" }
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-5 align-self-center" }
const _hoisted_22 = { class: "add-member-img" }
const _hoisted_23 = { class: "folder align-self-center" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "plus align-self-center" }, [
  /*#__PURE__*/_createVNode("p", null, "+")
], -1)
const _hoisted_25 = { class: "members" }
const _hoisted_26 = { class: "step-move" }
const _hoisted_27 = { class: "step-prev" }
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_29 = { class: "step-next" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_31 = { class: "final-container" }
const _hoisted_32 = { class: "final-block" }
const _hoisted_33 = { class: "container" }
const _hoisted_34 = { class: "final-wrap" }
const _hoisted_35 = { class: "convorally-moto" }
const _hoisted_36 = { class: "italic" }
const _hoisted_37 = { class: "final-img-wrap" }
const _hoisted_38 = /*#__PURE__*/_createVNode("p", null, "www. ", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("p", null, ".com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")
  const _component_TutorialStep = _resolveComponent("TutorialStep")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convoicon-blue.png`: 'timg/convoicon-blue.png' ,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _hoisted_5,
        _createVNode("h2", null, _toDisplayString(_ctx.$t('project_manager_app')), 1),
        _createVNode(_component_P, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('project_manager_description')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_TutorialStep)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('invitation')), 1),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('access_a_complete_list_of_all_the')) + " ", 1),
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('invitations_you_have_sent_out')), 1)
              ]),
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/invite.png`: 'timg/invite.png' ,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("h6", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('revert_to_any_of_your_projects')) + " ", 1),
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('to_start_adding_members_by')) + " ", 1),
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('tapping_on')) + " ", 1),
                      _createVNode("strong", null, " “" + _toDisplayString(_ctx.$t('add_member')) + ".”", 1)
                    ]),
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('you_can_see_the_entire_list_of_invitations')) + " ", 1),
                      _hoisted_19,
                      _createTextVNode(_toDisplayString(_ctx.$t('once_your_invitee_accepts_your_invitation')) + " ", 1),
                      _hoisted_20,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('to_join_your')) + " “" + _toDisplayString(_ctx.$t('project_name')) + ".”", 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("img", {
                        src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/folder.png`: 'timg/folder.png' ,
                        alt: ""
                      }, null, 8, ["src"])
                    ]),
                    _hoisted_24,
                    _createVNode("div", _hoisted_25, [
                      _createVNode("img", {
                        src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/client.png`: 'timg/client.png' ,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep2 && _ctx.redirectToStep2(...args)))
              }, [
                _hoisted_28
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep4 && _ctx.redirectToStep4(...args)))
              }, [
                _hoisted_30
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_31, [
      _createVNode("section", _hoisted_32, [
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/comment.png`: 'timg/comment.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('building_confidence_trust')) + " – ", 1),
                _createVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('one_convo_at_a_time')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convorally-text.png`: 'timg/convorally-text.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _hoisted_39
            ])
          ])
        ])
      ])
    ])
  ]))
}